import React from 'react';
import '../../scss/reusables/spinner.scss';
import loader from '../../images/gif/Loader.gif';

function Spinner() {

    return(
        <>
            <div className='spinner'>
                <img src={loader} alt='loader'></img>
            </div>
        </>
    )
}

export default Spinner;